import { render, staticRenderFns } from "./labelManagement.vue?vue&type=template&id=afda076a&scoped=true"
import script from "./labelManagement.vue?vue&type=script&lang=js"
export * from "./labelManagement.vue?vue&type=script&lang=js"
import style0 from "./labelManagement.vue?vue&type=style&index=0&id=afda076a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda076a",
  null
  
)

export default component.exports